import { createContext, useContext, useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";

const PricingCtx = createContext(null);
export const usePricing = () => useContext(PricingCtx);

export default function PricingProvider({ children }) {
  const [tiers, setTiers] = useState([]);
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    const snap = await getDoc(doc(db, "pricing", "default"));
    setTiers(snap.exists() ? snap.data().tiers : []);
    setLoading(false);
  }

  async function save(newTiers) {
    await setDoc(
      doc(db, "pricing", "default"),
      { tiers: newTiers, updatedAt: serverTimestamp() },
      { merge: true }
    );
    setTiers(newTiers);
  }

  useEffect(() => { load(); }, []);

  return (
    <PricingCtx.Provider value={{ tiers, setTiers, save, reload: load, loading }}>
      {children}
    </PricingCtx.Provider>
  );
}
